import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PageHeader from '../../common/pageHeader';
import LoginPage from '../../common/loginPage';
import ColorSkinWrapper from '../../common/colorSkinWrapper';
import { selectors as transitionRouterSelectors } from '../../common/transitionRouter';
import {
    selectors as bookmakersListSelectors,
    constants as bookmakersListConstants,
} from '../../common/bookmakersList';
import { clearRedirectLoginBookmaker } from '../bookmakersSwitcher.actions';
import { redirectToLoginBookmakerSelector } from '../bookmakersSwitcher.selectors';

export class SwitcherLoginPage extends Component {

    componentDidMount() {
        if (this.props.redirectToLoginBookmaker) {
            this.props.clearRedirectLoginBookmaker();
        }
    }

    render() {
        const { match, name, loginType } = this.props;
        const isExternalLogin = loginType === bookmakersListConstants.LOGIN_TYPE.IFRAME ||
            loginType === bookmakersListConstants.LOGIN_TYPE.WINDOW;
        return (
            <div
                className={`bs-popover__content
                            bs-switchBookmakers__content
                            bs-horizontalSlider__element`}
            >
                <ColorSkinWrapper
                    bookmakerName={name}
                    className={`bs-popover__content
                            bs-switchBookmakers__content
                            bs-horizontalSlider__element`}
                >
                    {!isExternalLogin ? <PageHeader
                        hideLogo={isExternalLogin}
                    /> : null}
                    <LoginPage match={match} showGamblingCompliance />

                </ColorSkinWrapper>
            </div>
        );
    }
}

SwitcherLoginPage.defaultProps = {
    redirectToLoginBookmaker: null,
};

SwitcherLoginPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            bookmaker: PropTypes.string,
        }),
    }).isRequired,
    name: PropTypes.string.isRequired,
    redirectToLoginBookmaker: PropTypes.string,
    clearRedirectLoginBookmaker: PropTypes.func.isRequired,
    loginType: PropTypes.string.isRequired,
};

const bookmakerInfoSelector =
    bookmakersListSelectors.createBookmakerInfoSelector(
        transitionRouterSelectors.feedSelector,
    );

const mapStateToProps = (state, props) => ({
    ...bookmakerInfoSelector(state, props),
    redirectToLoginBookmaker: redirectToLoginBookmakerSelector(state),
});

export default connect(
    mapStateToProps,
    {
        clearRedirectLoginBookmaker,
    },
)(SwitcherLoginPage);



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/loginPage/LoginPage.jsx